// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1537":"649bca0e","2568":"c6cd0746","2947":"11b01132","4541":"033e550c","4833":"649bca0e","5788":"033e550c","7979":"049f9643"}[chunkId] + ".chunk.css";
};